import EventDispatcher = createjs.EventDispatcher;
import { getLogger } from "@goodgamestudios/logger";
export class Pin {
    public static PIN_LOGGER = "pinLogger";

    private logger = getLogger(Pin.PIN_LOGGER);
    private _source: EventDispatcher;
    private executeCallback: Function;

    constructor(source: EventDispatcher) {
        this._source = source;
    }
    public get source(): EventDispatcher {
        return this._source;
    }

    public configure(): void {
        // empty
        this.logger.debug("Pin.config is not implemented");
    }

    public dispose(): void {
        // empty
        this.logger.debug("Pin.dispose is not implemented");
    }

    public execute(...rest: any[]): void {
        // empty
        this.logger.debug("Pin.execute is not implemented");
    }
}
